import React, { PropTypes } from 'react';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import FullScreenOverlay from '@bibliocommons/base-full-screen-overlay';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { Table } from '@bibliocommons/base-table';

import ShortFormattedDate from '../../../shared/ShortFormattedDate';

const tableFields = [
  {
    key: 'bib.briefInfo.title',
    headerKey: 'table_headings_title',
    type: 'string'
  },
  {
    key: 'bib.briefInfo.authors',
    headerKey: 'table_headings_author',
    type: 'string',
    transformationMap: (authors) => authors.map(author => <div>{author}</div>)
  },
  {
    key: 'errorResponseDTO.message',
    headerKey: 'table_headings_reason',
    type: 'string'
  },
  {
    key: 'checkout.dueDate',
    headerKey: 'table_headings_due_date',
    type: 'string',
    transformationMap: (value) => <ShortFormattedDate value={value} />
  }
];

export default class RenewFailureOverlay extends BcReactComponent {
  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      this.props.messagingActions.clearGlobalMessage();
    }
  }

  render() {
    const { open, handleClose, failures } = this.props;
    return (
      <div className="cp-renew-failure-overlay">
        <FullScreenOverlay
          handleClose={handleClose}
          open={open}>
          <FormattedMessage
            tagName="h2"
            id="unable_to_renew_title"
            values={{ count: failures.size }} />
          <FormattedMessage tagName="p" id="following_items_not_renewed" />
          <Table rows={failures} fields={tableFields} />
        </FullScreenOverlay>
      </div>
    );
  }
}

RenewFailureOverlay.propTypes = {
  open: PropTypes.bool,
  failures: ImmutablePropTypes.list,
  messagingActions: PropTypes.objectOf(PropTypes.func),
  handleClose: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/RenewFailureOverlay/RenewFailureOverlay.jsx